import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';

import api from '../../services/api';

const Container = styled.div`
  padding: 4px 0;
`;

const Title = styled.h2`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: ${(p) => p.theme.colors.text.primary};
  margin-bottom: 16px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
`;

const Card = styled.a`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  text-decoration: none;
  transition: box-shadow 0.15s;
  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 66, 66, 0.12);
  }
`;

const IconBox = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: ${(p) => p.theme.colors.primary.main}14;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.colors.primary.main};
`;

const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

const LinkTitle = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: ${(p) => p.theme.colors.text.primary};
  margin-bottom: 4px;
`;

const LinkDesc = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const EmptyState = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  color: #A0A8B4;
  text-align: center;
  padding: 40px;
`;

export default function MyLinksPage() {
  const { t } = useTranslation();
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/v1/important-links/my-links')
      .then((res) => {
        const result = res.data?.data;
        setLinks(Array.isArray(result) ? result : []);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  return (
    <Container>
      <Title>{t('importantLink.myLinks')}</Title>

      {links.length === 0 ? (
        <EmptyState>{t('importantLink.noLinks')}</EmptyState>
      ) : (
        <Grid>
          {links.map((link) => (
            <Card key={link.id} href={link.url} target="_blank" rel="noopener noreferrer">
              <IconBox>
                <ExternalLink size={20} />
              </IconBox>
              <Info>
                <LinkTitle>{link.title}</LinkTitle>
                <LinkDesc>{link.description || link.url}</LinkDesc>
              </Info>
            </Card>
          ))}
        </Grid>
      )}
    </Container>
  );
}
